class EventRegister {
  static prefix_event = 'on';
  static on(element, eventType, handler, options = false) {
    if (!(element instanceof Element)) {
      throw new Error('Provided target is not a DOM element.');
    }
    element.addEventListener(eventType, handler, options);
  }

  static off(element, eventType, handler, options = false) {
    if (!(element instanceof Element)) {
      throw new Error('Provided target is not a DOM element.');
    }
    element.removeEventListener(eventType, handler, options);
  }

  static handlerRegister = (selector, eventType, handler, options) => {
      const elements = document.querySelectorAll(selector);

      if (typeof handler !== 'function') {
        throw new Error('Provided handler is not a function.');
      }
      if (typeof eventType !== 'string') {
        throw new Error('Provided eventType is not a string.');
      }

      if (elements.size <= 0) return;

      for (const element of elements) {
        if (!!element[`on${eventType}`]) return;
        element.addEventListener(eventType, handler, options);
      }
    };

  static promisseRegister(selector, eventType, handler, options = false) {
    document.addEventListener("turbo:render", () => EventRegister.handlerRegister(selector, eventType, handler, options));
    document.addEventListener("DOMContentLoaded", () => EventRegister.handlerRegister(selector, eventType, handler, options));
  }
}

export default EventRegister;
